const QuestionPage = () => import('../views/QuestionPage');

const router = [
  {
    path: '/question-page',
    component: QuestionPage,
    props: true,
    meta: {
      requiresAuth: false,
    },
  },
];

export default router;

